var map = {
	"./bg.png": 386,
	"./bg2.png": 946,
	"./bg3.png": 299,
	"./bg4.png": 356,
	"./bg5 - Kopie.png": 252,
	"./bg5.png": 509,
	"./bg6.png": 830,
	"./chakren.png": 971,
	"./chiara.jpg": 599,
	"./chiaraTr.png": 209,
	"./chiaraTr3.png": 238,
	"./chiaraTr4.png": 353,
	"./chiaraTr5.png": 88,
	"./coaching.png": 225,
	"./coaching2.png": 87,
	"./downloadwork.png": 852,
	"./energiearbeit.png": 960,
	"./energieheilung.png": 114,
	"./energieheilung2.png": 970,
	"./hypnose.png": 625,
	"./hypnose2.png": 167,
	"./klangschalen.png": 589,
	"./logotrkl.png": 977,
	"./logotrkl2.png": 239,
	"./logotrkl3.png": 694,
	"./logotrkl4.png": 113,
	"./mentoring.png": 406,
	"./nlp.png": 641,
	"./nlp2.png": 983,
	"./nlp3.png": 990,
	"./tarot.png": 519,
	"./zert1.png": 341,
	"./zert2.png": 14,
	"./zert3.png": 303,
	"./zert4.png": 976,
	"./zert5.png": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;